import { Box, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MENU } from "../../../../../../locales/components/namespaces";

const SearchResults = ({
                           searchQuery,
                           searchResults,
                           loading = false,
                           onProductClick,
                       }) => {
    const { t } = useTranslation(MENU);

    if (!searchQuery.trim()) return null;

    return (
        <Box
            sx={{
                backgroundColor: "#ffffff",
                borderRadius: "5px",
                boxShadow: "0 12px 32px rgba(0, 0, 0, 0.12)",
                zIndex: 1201,
                width: "23rem",
                maxHeight: "420px",
                overflowY: "auto",
                scrollbarWidth: "none",
                animation: "slideDown 0.3s ease",
                "@keyframes slideDown": {
                    from: {
                        opacity: 0,
                        transform: "translateY(-10px)",
                    },
                    to: {
                        opacity: 1,
                        transform: "translateY(0)",
                    },
                },
            }}
        >
            <Stack sx={{ p: 2 }}>
                <Box sx={{ mb: 1.5 }}>
                    <Stack direction="row" spacing={0.8} alignItems="center">
            <span
                style={{
                    fontSize: "16px",
                    fontWeight: 700,
                    lineHeight: "120%",
                    fontFamily: "'Roboto Condensed', Arial, sans-serif",
                    color: "#333",
                }}
            >
              {t("search_found_results")}
            </span>

                        {!loading && (
                            <span
                                style={{
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    lineHeight: "120%",
                                    fontFamily: "'Roboto Condensed', Arial, sans-serif",
                                    color: "#999",
                                }}
                            >
                ({searchResults.length})
              </span>
                        )}
                    </Stack>
                </Box>

                <Stack spacing={0.5}>
                    {loading ? (
                        <Box
                            sx={{
                                fontSize: 14,
                                fontWeight: 500,
                                color: "#999",
                                textAlign: "center",
                                p: 3,
                            }}
                        >
                            {t("search_loading")}
                        </Box>
                    ) : searchResults.length > 0 ? (
                        searchResults.map((result) => (
                            <Box
                                key={result.id}
                                onClick={() => onProductClick(result.id)}
                                sx={{
                                    display: "flex",
                                    gap: 1,
                                    p: 1,
                                    borderRadius: "8px",
                                    cursor: "pointer",
                                    transition: "background 0.2s ease",
                                    bgcolor: "#F0F0F0",
                                    "&:hover": {
                                        backgroundColor: "#e8e8e8",
                                    },
                                    "&:active": {
                                        backgroundColor: "#ddd",
                                    },
                                }}
                            >
                                <Box
                                    component="img"
                                    src={result.image}
                                    alt={result.title}
                                    sx={{
                                        width: 80,
                                        height: 70,
                                        objectFit: "cover",
                                        borderRadius: "6px",
                                        flexShrink: 0,
                                        backgroundColor: "#f5f5f5",
                                    }}
                                />

                                <Stack
                                    spacing={1}
                                    sx={{
                                        flex: 1,
                                        justifyContent: "center",
                                        minWidth: 0,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            fontSize: "14px",
                                            fontWeight: 400,
                                            fontFamily: "'Roboto Condensed', Arial, sans-serif",
                                            color: "#333",
                                            lineHeight: "120%",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            display: "-webkit-box",
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: "vertical",
                                        }}
                                    >
                                        {result.title}
                                    </Box>

                                    <Box
                                        sx={{
                                            fontSize: "16px",
                                            fontWeight: 700,
                                            fontFamily: "'Roboto Condensed', Arial, sans-serif",
                                            lineHeight: "120%",
                                            color: "#333",
                                        }}
                                    >
                                        {result.price}
                                    </Box>
                                </Stack>
                            </Box>
                        ))
                    ) : (
                        <Box
                            sx={{
                                fontSize: 14,
                                fontWeight: 500,
                                color: "#999",
                                textAlign: "center",
                                p: 3,
                            }}
                        >
                            {t("search_no_results")}
                        </Box>
                    )}
                </Stack>
            </Stack>
        </Box>
    );
};

export default SearchResults;